import { SET_WALLET, RESET_WALLET } from "../../types";
import { Action } from "../../../models/Core.models";

export interface WalletState {
  exists: boolean;
  availableBalance?: number;
}

const INITIAL_STATE: WalletState = {
  exists: false,
  availableBalance: undefined,
};

export default function wallet(state = INITIAL_STATE, action: Action<WalletState>): WalletState {
  switch (action.type) {
    case SET_WALLET:
      return action.payload;
    case RESET_WALLET:
      return INITIAL_STATE;
    default:
      return state;
  }
}
